/**
 * 壳内 crash 面包屑的旁路注入口（形态照 `src/traffic/traffic-pages.ts` 的
 * `setShellTrafficReporter` 先例）：App.vue 静态 import 本模块在导航 watch
 * 处记录面包屑，真实 reporter 由 crash-shell（动态 import，仅
 * `VITE_CRASH_ENABLED === 'true'` 时加载）装配时注入；off / 未装配时为
 * 空操作——crash 旁路绝不打断宿主。
 */

type ShellCrashBreadcrumbReporter = (category: string, message: string) => void

let shellCrashBreadcrumbReporter: ShellCrashBreadcrumbReporter | null = null

/** 装配完成时由 crash-shell 注入真实 reporter；默认（未装配/off）为空操作。 */
export function setShellCrashBreadcrumbReporter(reporter: ShellCrashBreadcrumbReporter | null): void {
  shellCrashBreadcrumbReporter = reporter
}

/**
 * 记录壳内导航面包屑（activeTab/权限分区/模块菜单切换，与流量上报同点，
 * 见 App.vue `reportCurrentWorkspacePage`）。未装配（off）时静默跳过。
 */
export function reportShellCrashBreadcrumb(category: string, message: string): void {
  try {
    shellCrashBreadcrumbReporter?.(category, message)
  } catch {
    // crash 采集链自身故障不得打断宿主导航。
  }
}

/** 清空 reporter（测试隔离用；生产路径无需调用）。 */
export function resetShellCrashBreadcrumbs(): void {
  shellCrashBreadcrumbReporter = null
}
